export default __webpack_public_path__ + "static/media/DSC_0585.2349b67a.jpg";